export default {
  app: {
    languagePopup: {
      title: 'Вы сейчас находитесь на английской версии {logo}',
      subtitle: 'Хотите переключиться на предпочитаемый язык?',
      cta: 'Переключиться на {lang}',
    },
  },
};
